// src/order-status.ts
var ORDER_TRANSITIONS = {
  pending: ["confirmed", "rejected", "cancelled"],
  confirmed: ["preparing", "rejected", "cancelled"],
  preparing: ["out_for_delivery", "rejected", "cancelled"],
  out_for_delivery: ["delivered", "delivery_failed", "rejected", "cancelled"],
  delivered: [],
  cancelled: [],
  rejected: [],
  delivery_failed: []
};

export {
  ORDER_TRANSITIONS
};
